<div style="display: flex; flex-direction:column; align-items: center; justify-content: center; width: 100%; height: 100%;">
  <div style="display: flex;">
    <div style="width: 100%">
      @if(assessment) {
        <h1 style="font-size: 1.5rem">{{ assessment.name }}</h1>
      }
    </div>
  </div>

  <lib-content-loader *ngIf="loading" aria-busy="true"></lib-content-loader>
  <div *ngIf="!loading && valid_token" [formGroup]="form" style="margin-top: 1rem; width: 500px">

    <div >
      <mat-form-field actions appearance="outline" style="width: 100%;">
        <mat-label>First Name</mat-label>
        <input matInput type="text" formControlName="first_name" required data-testid="respect-first-name-input">
        <mat-error *ngIf="form.get('first_name')?.errors">
          First name is required.
        </mat-error>
      </mat-form-field>

    </div>

    <div>
      <mat-form-field actions appearance="outline" style="width: 100%;">
        <mat-label>Last Name</mat-label>
        <input matInput type="text" formControlName="last_name" required data-testid="respect-last-name-input">
        <mat-error *ngIf="form.get('last_name')?.errors">
          Last name is required.
        </mat-error>
      </mat-form-field>
    </div>

    <div>
      <mat-form-field actions appearance="outline" style="width: 100%;">
        <mat-label>Email</mat-label>
        <input matInput type="text" formControlName="email_address" required data-testid="respect-email-input">
        @if (form.get('email_address')?.errors) {
          <mat-error>
            Email Address is required.
          </mat-error>
        }
        @else if (form.get('email_address')?.hasError('pattern')) {
          <mat-error>
            Please enter a valid email address.
          </mat-error>
        }
      </mat-form-field>
    </div>

    <div>
      <mat-form-field actions appearance="outline" style="width: 100%;">
        <mat-label>Organization Name</mat-label>
        <input matInput type="text" formControlName="org_name" data-testid="respect-org-name-input">
      </mat-form-field>
    </div>

    @if (outOfInventory) {
      <div class="inline-message inline-message--warning" data-testid="respect-out-of-inventory-message">
        <mat-icon aria-hidden="true">warning</mat-icon>
        <span>Your organization has no assessments remaining. Please contact your organization's administrator.</span>
      </div>
    }

    <div class="button-container">
      <lib-button color="primary" mat-button [disabled]="!form.valid" (click)="startAssessment()" data-testid="respect-start-button">
        Start!
      </lib-button>

      @if (showOkta) {
        <button
        type="button"
        class="okta-login-bar"
        [disabled]="oktaService.getIsAuthenticated()"
        (click)="oktaLogin()"
        data-testid="respect-okta-login-button"
       >
         <img class="okta-logo" src="assets/okta-icon.svg" alt="Okta" />
         <span>{{oktaButtonText}}</span>
       </button>
       <small class="okta-note">Okta for Cigna Only</small>
      }
    </div>

  </div>

  @if (!loading) {
    @if (!valid_token) {
    <div class="region-error region-error--danger" data-testid="respect-error">
      <mat-icon aria-hidden="true">error</mat-icon>
      <span>Token invalid, please contact system admin for further assistance.</span>
    </div>
    }
  }

  <a href="#" class="cookie-settings-link" (click)="$event.preventDefault(); consent.reset()">Manage cookie settings</a>
</div>
